import { Image, Stack, Text, Title } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { COMPANY_NAME } from "../../constants";

export const OverviewHeader = () => {
  const i18n = useI18n();

  return (
    <>
      <Stack>
        <Stack direction="row" alignItems="center" gap={3}>
          <Title title={i18n.trans(t("flights_airline_portal_superuser_overview_title"))} variant="headline_1" />
          <Image
            asset={{
              setName: "images-genius",
              assetName: "GeniusLogo",
            }}
            height={4}
          />
        </Stack>
        <Text variant="body_2">
          {i18n.trans(
            t("flights_airline_portal_superuser_overview_subheader_one", { variables: { b_companyname: COMPANY_NAME } })
          )}
        </Text>
      </Stack>
    </>
  );
};
